<template>
    <div class="blog-post-products">
        <div class="blog-post-products-title">
            {{ showcase.name }}
        </div>
        <div v-for="product in products" :key="product.id" class="mb-3 row">
            <ShowcaseProductCategories :product="product" :megamenu="false"/>
        </div>
    </div>
</template>
<script>
import ShowcaseProductCategories from "~/components/ShowcaseProductCategories";
export default {
    components: {
        ShowcaseProductCategories
    },
    data(){
        return{
            products: [],
            showcase: {}
        }
    },
    async fetch(){
        await this.$axios.$get(`api/v1/ecommerce/products/?showcase_code=${this.$wdconfig.modules.showcase.home}&limit=5&show_showcases=true&thumb=sim&x=340&show_payments=true`).then((res)=>{
            try {
                this.products = res.data
                this.showcase = res.metadata.showcases[0]
            } catch (e) {
                console.error(e)
            }
        }).catch((e) => {
            console.error(e)
        })
    }
}
</script>
